export enum CondicionIIBB {
    Inscripto = 0,
    NoInscripto = 1,
    Exento = 2,
    ConvenioMultilateral = 3,
}